export default function multiply(x = 0, y = 0) {
    return x * y;
}
;
